import { agendaCountryOptions } from './agendaTherapyTypes';
import { patientLinkOptions } from './childInterests';

export const PACIENTE_CONTACTO_CLAVES = [
  'acudiente_telefono',
  'acudiente_telefono_alt',
  'acudiente_correo',
  'acudiente_tel_emergencia',
];

const radioSiNo = [
  { id: 'si', label: 'Sí' },
  { id: 'no', label: 'No' },
];

export const pacientePlanillaSecciones = () => [
  {
    id: 'identificacion',
    titulo: 'Identificación',
    campos: [
      { clave: 'nombre', etiqueta: 'Nombre completo del paciente', tipo: 'texto', ancho: 'wide' },
      {
        clave: 'documento_tipo',
        etiqueta: 'Tipo de identificación',
        tipo: 'radio',
        opciones: [
          { id: 'cedula', label: 'Cédula' },
          { id: 'pasaporte', label: 'Pasaporte' },
          { id: 'otro', label: 'Otro' },
        ],
      },
      { clave: 'documento_numero', etiqueta: 'Número de identificación', tipo: 'texto' },
      {
        clave: 'pais',
        etiqueta: 'País / Nacionalidad',
        tipo: 'select',
        opciones: agendaCountryOptions.map((item) => ({ id: item.id, label: item.label })),
      },
      {
        clave: 'sexo',
        etiqueta: 'Sexo',
        tipo: 'radio',
        opciones: [
          { id: 'masculino', label: 'Masculino' },
          { id: 'femenino', label: 'Femenino' },
        ],
      },
      { clave: 'fecha_nacimiento', etiqueta: 'Fecha de nacimiento', tipo: 'date' },
      { clave: 'edad', etiqueta: 'Edad', tipo: 'edad' },
      { clave: 'foto', etiqueta: 'Fotografía del paciente', tipo: 'foto' },
    ],
  },
  {
    id: 'escolar',
    titulo: 'Escolar',
    campos: [
      { clave: 'centro_educativo', etiqueta: 'Centro educativo', tipo: 'texto', ancho: 'wide' },
      { clave: 'grado', etiqueta: 'Grado que cursa actualmente', tipo: 'texto' },
      {
        clave: 'turno',
        etiqueta: 'Turno',
        tipo: 'radio',
        opciones: [
          { id: 'manana', label: 'Mañana' },
          { id: 'tarde', label: 'Tarde' },
        ],
      },
      {
        clave: 'dificultad_academica',
        etiqueta: '¿Presenta alguna dificultad académica reportada?',
        tipo: 'radio',
        opciones: radioSiNo,
      },
      {
        clave: 'dificultad_academica_detalle',
        etiqueta: 'En caso afirmativo, describa brevemente',
        tipo: 'textarea',
        ancho: 'wide',
      },
    ],
  },
  {
    id: 'diagnostica',
    titulo: 'Diagnóstica',
    campos: [
      {
        clave: 'tiene_diagnostico',
        etiqueta: '¿Cuenta actualmente con algún diagnóstico?',
        tipo: 'radio',
        opciones: radioSiNo,
      },
      { clave: 'diagnosticos', etiqueta: 'Diagnóstico(s)', tipo: 'textarea', ancho: 'wide' },
      { clave: 'fecha_diagnostico', etiqueta: 'Fecha aproximada del diagnóstico', tipo: 'date' },
      {
        clave: 'especialista_diagnostico',
        etiqueta: 'Especialista que realizó o confirmó el diagnóstico',
        tipo: 'texto',
        ancho: 'wide',
      },
      {
        clave: 'especialidad_diagnostico',
        etiqueta: 'Especialidad',
        tipo: 'checkboxes',
        opciones: [
          { id: 'neurologia', label: 'Neurología' },
          { id: 'pediatria', label: 'Pediatría' },
          { id: 'psicologia', label: 'Psicología' },
          { id: 'psiquiatria', label: 'Psiquiatría' },
          { id: 'fonoaudiologia', label: 'Fonoaudiología' },
          { id: 'otra', label: 'Otra' },
        ],
        ancho: 'wide',
      },
      { clave: 'especialidad_otra', etiqueta: 'Otra especialidad', tipo: 'texto' },
      {
        clave: 'institucion_atencion',
        etiqueta: 'Institución / clínica donde recibe atención',
        tipo: 'texto',
        ancho: 'wide',
      },
      {
        clave: 'recibe_tratamiento',
        etiqueta: '¿Actualmente recibe tratamiento o seguimiento?',
        tipo: 'radio',
        opciones: radioSiNo,
      },
      {
        clave: 'especialistas_tratamiento',
        etiqueta: 'Indique con qué especialista(s)',
        tipo: 'texto',
        ancho: 'wide',
      },
    ],
  },
  {
    id: 'sobre',
    titulo: 'Sobre el paciente',
    campos: [
      {
        clave: 'descripcion_paciente',
        etiqueta:
          'Describa brevemente al paciente: incluya aspectos importantes sobre su comportamiento, comunicación, aprendizaje, interacción social, fortalezas, dificultades, intereses y cualquier situación que considere que el especialista debe conocer.',
        tipo: 'textarea',
        ancho: 'wide',
      },
      {
        clave: 'motivo_consulta',
        etiqueta:
          '¿Cuál es el principal motivo por el que solicita atención, evaluación o terapia para el paciente?',
        tipo: 'textarea',
        ancho: 'wide',
      },
    ],
  },
  {
    id: 'acudiente',
    titulo: 'Acudiente',
    campos: [
      { clave: 'acudiente_nombre', etiqueta: 'Nombre completo', tipo: 'texto', ancho: 'wide' },
      {
        clave: 'acudiente_parentesco',
        etiqueta: 'Parentesco con el paciente',
        tipo: 'select',
        opciones: patientLinkOptions.map((item) => ({ id: item.id, label: item.label })),
      },
      { clave: 'acudiente_documento', etiqueta: 'Cédula / Pasaporte', tipo: 'texto' },
      { clave: 'acudiente_telefono', etiqueta: 'Teléfono principal', tipo: 'texto', contacto: true },
      { clave: 'acudiente_telefono_alt', etiqueta: 'Teléfono alternativo', tipo: 'texto', contacto: true },
      { clave: 'acudiente_correo', etiqueta: 'Correo electrónico', tipo: 'texto', contacto: true },
      {
        clave: 'acudiente_direccion',
        etiqueta: 'Dirección / área de residencia',
        tipo: 'textarea',
        ancho: 'wide',
      },
      {
        clave: 'acudiente_contacto_emergencia',
        etiqueta: 'Persona de contacto en caso de emergencia',
        tipo: 'texto',
        ancho: 'wide',
      },
      {
        clave: 'acudiente_tel_emergencia',
        etiqueta: 'Teléfono de emergencia',
        tipo: 'texto',
        contacto: true,
      },
    ],
  },
  {
    id: 'adicional',
    titulo: 'Adicional',
    campos: [
      {
        clave: 'terapias_anteriores',
        etiqueta: '¿Ha recibido terapias anteriormente?',
        tipo: 'radio',
        opciones: radioSiNo,
      },
      { clave: 'tipo_terapia', etiqueta: 'Tipo de terapia', tipo: 'texto', ancho: 'wide' },
      {
        clave: 'terapias_actuales',
        etiqueta: '¿Recibe terapias actualmente?',
        tipo: 'radio',
        opciones: radioSiNo,
      },
      { clave: 'terapias_donde', etiqueta: '¿Dónde?', tipo: 'texto', ancho: 'wide' },
      {
        clave: 'observaciones',
        etiqueta: 'Observaciones importantes',
        tipo: 'textarea',
        ancho: 'wide',
      },
    ],
  },
];

export const planillaValores = (planilla) => {
  const valores = {};

  ((planilla && planilla.secciones) || []).forEach((seccion) => {
    (seccion.campos || []).forEach((campo) => {
      if (campo.clave) {
        valores[campo.clave] = campo.valor;
      }
    });
  });

  return valores;
};

export const armarPlanillaPaciente = (valores) => {
  const mapa = valores && typeof valores === 'object' ? valores : {};

  return {
    secciones: pacientePlanillaSecciones().map((seccion) => ({
      ...seccion,
      campos: seccion.campos.map((campo) => ({
        ...campo,
        valor: mapa[campo.clave] !== undefined && mapa[campo.clave] !== null ? mapa[campo.clave] : '',
      })),
    })),
  };
};

export const sexoDesdeGenero = (genero) => {
  if (genero === 'nina' || genero === 'mujer' || genero === 'femenino') {
    return 'femenino';
  }

  if (genero === 'nino' || genero === 'hombre' || genero === 'masculino') {
    return 'masculino';
  }

  return '';
};

export const generoDesdeSexo = (sexo, vinculo) => {
  if (sexo === 'femenino') {
    return vinculo === 'yo_mismo' ? 'mujer' : 'nina';
  }

  if (sexo === 'masculino') {
    return vinculo === 'yo_mismo' ? 'hombre' : 'nino';
  }

  return '';
};

export const valoresDesdePaciente = (patient) => {
  const fromPlanilla = planillaValores(patient && patient.planilla);
  const extra = (patient && patient.planillaValores) || {};
  const vinculo =
    (patient && patient.vinculo) || extra.acudiente_parentesco || fromPlanilla.acudiente_parentesco || 'hijo';

  return {
    ...fromPlanilla,
    ...extra,
    nombre: (patient && patient.nombre) || extra.nombre || fromPlanilla.nombre || '',
    documento_tipo:
      (patient && patient.documentoTipo) || extra.documento_tipo || fromPlanilla.documento_tipo || 'cedula',
    documento_numero:
      (patient && patient.documentoNumero) || extra.documento_numero || fromPlanilla.documento_numero || '',
    pais: (patient && patient.pais) || extra.pais || fromPlanilla.pais || '',
    fecha_nacimiento:
      (patient && patient.fechaNacimiento) || extra.fecha_nacimiento || fromPlanilla.fecha_nacimiento || '',
    sexo: sexoDesdeGenero(patient && patient.genero) || extra.sexo || fromPlanilla.sexo || '',
    acudiente_parentesco: vinculo,
  };
};

export const pacienteDesdeValores = (current, valores) => {
  const mapa = valores && typeof valores === 'object' ? valores : {};
  const vinculo = mapa.acudiente_parentesco || (current && current.vinculo) || 'hijo';

  return {
    ...(current || {}),
    nombre: (mapa.nombre || '').trim(),
    documentoTipo: mapa.documento_tipo || 'cedula',
    documentoNumero: mapa.documento_numero || '',
    pais: mapa.pais || '',
    fechaNacimiento: mapa.fecha_nacimiento || '',
    vinculo,
    genero: generoDesdeSexo(mapa.sexo, vinculo) || (current && current.genero) || '',
    planillaValores: mapa,
  };
};

export const ocultarContactoPlanilla = (planilla) => {
  if (!planilla || !Array.isArray(planilla.secciones)) {
    return planilla;
  }

  return {
    ...planilla,
    secciones: planilla.secciones.map((seccion) => ({
      ...seccion,
      campos: (seccion.campos || []).filter((campo) => PACIENTE_CONTACTO_CLAVES.indexOf(campo.clave) === -1),
    })),
  };
};
